import { slideUp, slideToggle } from "../helpers/Animations.js";

/**
 * Клас для обробки спойлерів (spollers)
 * і підтримкою опцій: тільки один відкритий, регулярні спойлери тощо.
 *
 * @version 1.1.0
 */
export default class Spollers {
    constructor(options = {}) {
        this.containerSelector = options.containerSelector || "[data-spollers]";
        this.spollerSelector = options.spollerSelector || "[data-spoller]";
        this.containers = Array.from(document.querySelectorAll(this.containerSelector));
        this.oneAtATime = options.oneAtATime || false;
    }

    init() {
        if (!this.containers.length) return;

        this.containers.forEach((container) => {
            this.initContainer(container);
            this.setBodies(container, true);
        });
    }

    initContainer(container) {
        container.classList.add("_init");

        // Визначаємо чи в цьому контейнері дозволено тільки один відкритий спойлер
        container._oneAtATime = container.hasAttribute("data-one-spoller") || this.oneAtATime;

        const spollers = Array.from(container.querySelectorAll(this.spollerSelector));

        // Підключаємо обробник кліку
        container.addEventListener("click", (e) => this.onClick(e, container));
    }

    onClick(e, container) {
        const target = e.target.closest(this.spollerSelector);
        if (!target) return;
        e.preventDefault();

        const isActive = target.classList.contains("_active");

        // Якщо дозволено тільки один відкритий і юзер відкриває інший — закрити інші
        if (container._oneAtATime && !isActive) {
            this.closeAll(container, target);
        }

        // Переключаємо стан цільового спойлера
        target.classList.toggle("_active");

        const body = target.nextElementSibling;
        if (body) slideToggle(body, 300);
    }

    /**
     * Закриває всі відкриті спойлери в контейнері.
     * Якщо передано except — пропускає його (не закриває).
     * @param {HTMLElement} container
     * @param {HTMLElement|null} except
     */
    closeAll(container, except = null) {
        const actives = Array.from(container.querySelectorAll(this.spollerSelector + "._active"));
        actives.forEach((active) => {
            if (except && active === except) return;
            active.classList.remove("_active");
            const body = active.nextElementSibling;
            if (body) slideUp(body, 300);
        });
    }

    /**
     * Встановлює початкову видимість контенту спойлерів
     * @private
     * @param {HTMLElement} container
     * @param {boolean} hide - якщо true, всі тіла спойлерів ховаються (крім активних)
     */
    setBodies(container, hide = true) {
        const spollers = Array.from(container.querySelectorAll(this.spollerSelector));
        spollers.forEach((spoller) => {
            const body = spoller.nextElementSibling;
            if (!body) return;
            if (hide) {
                body.hidden = !spoller.classList.contains("_active");
            } else {
                body.hidden = false;
            }
        });
    }
}
